import { cx } from 'class-variance-authority';
import Link from 'next/link';
import type { ReactNode } from 'react';
import type { ButtonVariantsProps } from './styles';
import { buttonStyles } from './styles';

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    Omit<ButtonVariantsProps, 'disabled'> {
  endIcon?: ReactNode;
  startIcon?: ReactNode;
  href?: string;
  target?: string;
}

export function BaseButton({
  onClick,
  children,
  intent,
  size,
  weight,
  className,
  endIcon,
  startIcon,
  href,
  disabled,
  target,
  ...props
}: ButtonProps) {
  const classes = cx(buttonStyles({ intent, size, disabled, weight }), className);

  if (href) {
    return (
      <Link
        className={classes}
        href={disabled ? '#' : href}
        target={target}
        rel={target === '_blank' ? 'noopener noreferrer' : undefined}
      >
        {startIcon}
        {children}
        {endIcon}
      </Link>
    );
  }

  return (
    <button disabled={disabled} className={classes} onClick={onClick} {...props}>
      {startIcon}
      {children}
      {endIcon}
    </button>
  );
}